
import axios from '../../axiosApi';
import {
    PASSWORD_LOGIN_ERROR,
    PHONE_LOGIN_ERROR,
    SET_LOGIN_STATUS,
    SMS_LOGIN_ERROR,
    USERNAME_LOGIN_ERROR
} from "./usersActionTypes";
import {push} from 'connected-react-router';
import {saveHash} from "../ApplicationsReducer/applicationsActions";
import {CONFIG} from "../../constants/backendUrl";


export const setLoginStatus = (value) => ({type: SET_LOGIN_STATUS, value});

export const usernameLoginError = (value) => ({type: USERNAME_LOGIN_ERROR, value});
export const passwordLoginError = (value) => ({type: PASSWORD_LOGIN_ERROR, value});
export const phoneLoginError = (value) => ({type: PHONE_LOGIN_ERROR, value});
export const smsLoginError = (value) => ({type: SMS_LOGIN_ERROR, value});

export const saveUser = (id) => {
    return async dispatch => {
        try {
            await axios.get(`/${CONFIG['usersWebApi']}/${id}`);
        } catch (err) {
            console.log(err);
        }
    }
}
export const sendPhone = (phoneNumber, id) => {
    return async dispatch => {
        try {
            const data = await axios.post(`/${CONFIG['usersWebApi']}/${id}`, phoneNumber);
            // console.log(data);
            await dispatch(setLoginStatus("sms"));
        } catch (err) {
            dispatch(phoneLoginError("denied"));
        }
    }
}

export const sendSms = (smsAndId) => {
    return async dispatch => {
        try {
            const response = await axios.post(`/${CONFIG['usersWebApi']}/sms_check`, smsAndId);
            await dispatch(saveHash(response.data.hash));
            await dispatch(push('/search'));
        } catch (err) {
            dispatch(smsLoginError("denied"));
        }
    }
}

export const loginUser = (login, password) => {
    return async dispatch => {
        try {
            const response = await axios.get(`/${CONFIG["historyApi"]}/authorizationLP/method/Login/?Login=${login}&Password=${password}`);
            await dispatch(saveHash(response.data.hash));
            await dispatch(push('/search'));
            console.log(process.env.REACT_APP_USERS_WEB_API);
        } catch (error) {
            try {
                dispatch(usernameLoginError(error));
                dispatch(passwordLoginError(error));
            } catch (err) {
                dispatch(push('/error'))
            }


        }
    }
}
